<!-- eslint-disable -->
<template>
  <v-footer 
    id="home-footer"
    color="grey darken-4"
    dark min-height="72"
  >
    <v-container>
      <v-row>
        <v-col 
          class="text-right"
          cols="6"
          md="2"
        >
          <base-img
            :src="require('@/assets/ue.jpg')"
            class="mr-0"
            contain
            max-height="200"
          />
        </v-col>
        <v-col 
          class="text-left" 
          cols="6" 
          md="10"
        >
          <p>
            PROYECTOS E INSTALACIONES ROSMAR, S.L ha sido beneficiaria del Fondo
            Europeo de Desarrollo Regional cuyo objetivo es promover el
            desarrollo tecnológico, la innovación y una investigación de
            calidad; garantizar un mejor uso de las tecnologías de la
            información y conseguir un tejido empresarial más competitivo y
            gracias al “cálculo de la huella de carbono corporativa, plan
            estratégico de la empresa (Business Plan) y auditoría para la
            organización de la producción”, que ha mejorado la competitividad de
            su negocio. Esta acción ha tenido lugar durante el ejercicio 2022.
            Para ello ha contado con el apoyo del Programa Innocámaras de la
            Cámara de Comercio Industria, Servicios y Navegación de Sevilla.
          </p>
          <p>Una manera de hacer Europa</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col 
          class="text-right"
          cols="6"
          md="2"
        >
          <base-img
            :src="require('@/assets/cartel_camara_comercio.png')"
            class="mr-0"
            contain
            max-height="200"
          />
        </v-col>
        <v-col 
          class="text-left"
          cols="6"
          md="10"
          >
          <p>
            ROSMAR SL ha sido beneficiaria del FSE, cuyo objetivo es promover la
            sostenibilidad y la calidad en el empleo, y gracias al que ha
            procedido a la contratación de jóvenes beneficiarios del Sistema
            Nacional de Garantía Juvenil, apoyando la reducción de la tasa de
            desempleo juvenil en España a través del fomento de la contratación
            (28/8/2021). Para ello ha contado con el apoyo del “Plan de
            Capacitación – PICE” de la Cámara de Comercio de Sevilla.
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center text-md-right" cols="2" md="1">
          <a
            class="white--text pa-1 pa-md-0"
            href="https://firebasestorage.googleapis.com/v0/b/rosmar-sl.appspot.com/o/certificados%2Fcertificado%20iso%209001.pdf?alt=media&token=9dce0de7-f1f4-42f4-9fb0-4dc33b9c8f18"
            target="_blanck"
          >
            <base-img
              :src="require('@/assets/ISO-9001-2015-Logo.png')"
              class="mr-3 hidden-xs-only"
              contain
              width="56"
            />
          </a>
        </v-col>
        <v-col class="text-center text-md-right" cols="2" md="1">
          <a
            class="white--text pa-1 pa-md-0"
            href="https://firebasestorage.googleapis.com/v0/b/rosmar-sl.appspot.com/o/certificados%2Fcertificado%20iso%2014001.pdf?alt=media&token=1cf70c1c-8a0f-4860-969c-11e4df2e9275"
            target="_blanck"
          >
            <base-img
              :src="require('@/assets/ISO14001.png')"
              class="mr-3 hidden-xs-only"
              contain
              width="56"
            />
          </a>
        </v-col>
        <v-col class="text-center text-md-right" cols="2" md="1">
          <a
            class="white--text pa-1 pa-md-0"
            href="https://firebasestorage.googleapis.com/v0/b/rosmar-sl.appspot.com/o/certificados%2FCERTIFICADO%20DE%20EMPRESA%20DE%20GASES%20FLUORADOS.PDF?alt=media&token=a692267b-dd72-4cff-850e-5f6a7cfd6bf6"
            target="_blanck"
          >
            <base-img
              :src="require('@/assets/frio-blanco.svg')"
              class="mr-3 hidden-xs-only"
              contain
              width="32"
            />
          </a>
        </v-col>
        <v-col class="text-center text-md-right" cols="2" md="1">
          <a
            class="white--text pa-1 pa-md-0"
            href="https://firebasestorage.googleapis.com/v0/b/rosmar-sl.appspot.com/o/certificados%2FClasificaci%C3%B3n%20Rosmar.pdf?alt=media&token=1045e6bc-afbc-4721-944e-d4fbfc9cd100"
            target="_blanck"
          >
            <base-img
              :src="require('@/assets/rolece-logo.png')"
              class="mr-3 hidden-xs-only"
              contain
              width="56"
            />
          </a>
        </v-col>
        <v-col class="text-center text-md-right" cols="2" md="1">
          <a
            class="white--text pa-1 pa-md-0"
            href="https://firebasestorage.googleapis.com/v0/b/rosmar-sl.appspot.com/o/certificados%2Fcertificado%20iso%2014001.pdf?alt=media&token=1cf70c1c-8a0f-4860-969c-11e4df2e9275"
            target="_blanck"
          >
            <base-img
              :src="require('@/assets/sello_ISO.jpg')"
              class="mr-3 hidden-xs-only"
              contain
              width="56"
            />
          </a>
        </v-col>
        <v-col cols="12" md="2">
          <div
            class="d-flex flex-wrap justify-md-start justify-center justify-md-none"
          >
            <template v-for="(s, i) in social" :key="s.title">
              <a
                class="white--text pa-1 pa-md-0"
                :href="s.link"
                target="_blanck"
                v-text="s.title"
              />

              <v-responsive
                v-if="i < social.length - 1"
                :key="`divider-${s.title}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </div>
        </v-col>

        <v-col class="text-center text-md-right" cols="12" md="6">
          Copyright &copy; {{ new Date().getFullYear() }} Proyectos e
          Instalaciones Rosmar, SL
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      social: [
        {
          title: 'Indeed',
          link:
            'https://es.indeed.com/ofertas?q=Rosmar&l=Sevilla+provincia&radius=50',
        },
        {
          title: 'Linkedin',
          link: 'https://www.linkedin.com/company/rosmarsl',
        // link: 'https://www.linkedin.com/company/proyectos-e-instalaciones-rosmar-sl-/',
        },
      ],
    }),
  }
</script>

<style lang="sass">
#home-footer a
  text-decoration: none
</style>
